/**
 * tailwind plugins was written using extend configuration feature. It was used to give our modal sizes into the existing config.

 * ? https://tailwindcss.com/docs/plugins#extending-the-configuration
 */
import plugin from 'tailwindcss/plugin'

export default plugin(
  function headingTypographyPlugin({ matchUtilities, theme }) {
    matchUtilities(
      {
        heading: (value) => ({
          fontSize: value[0],
          lineHeight: value[1],
          fontWeight: value[2],
          letterSpacing: value[3],
        }),
      },
      { values: theme('heading') },
    )
  },
  {
    theme: {
      heading: {
        1: ['2rem', '3rem', 500, 0],
        2: ['1.5rem', '2rem', 500, 0],
        3: ['1.25rem', '1.75rem', 500, 0],
        4: ['0.825rem', '1.25rem', 500, 0],
      },
    },
  },
)
